/* eslint-disable react/no-children-prop */
import React from 'react'
import Responsive from 'react-responsive'

export const Default = ({ children }) => (
    <Responsive minWidth={768} children={children} />
)

export const Mobile = ({ children }) => (
    <Responsive maxWidth={767} children={children} />
)

export const Desktop = ({ children }) => (
    <Responsive minWidth={992} children={children} />
)

export const Tablet = ({ children }) => (
    <Responsive minWidth={768} maxWidth={992} children={children} />
)
